// extracted by mini-css-extract-plugin
module.exports = {"card":"countryCard_card__35izK","card_content":"countryCard_card_content__RGvk5","img_fluid":"countryCard_img_fluid__3oIH_"};